export const RETURN_LABEL_CREATED_EVENT = 'returnRequestSubmitted'
export const CANCELLATION_REQUESTED_EVENT = 'cancellationRequested'
